export const STORAGE_KEYS = {
  selectedMerchant: 'selectedMerchant',
  adTechMerchant: 'adTechMerchant',
  finishedCollectPhone: 'tamara-finished-collect-phone-number',
  firedEvents: 'firedEvents',
  customColumns: 'customColumns',
  farahCustomColumns: 'farah_customColumns',
  hideFarhaBanner: 'hideFarhaBanner',
  isDownloadBannerHidden: 'isDownloadBannerHidden',
  isEidBannerHidden: 'isEidBannerHidden',
  hideEligibleNoti: 'hideEligibleNoti',
  adsMultipleCountryCampaignPausedDismissed:
    'ads_multiple_country_campaign_paused_dismissed',

  adsCampaignCreateSessionId: 'ads_campaign_create_session_id',
  adsCampaignEditSessionId: 'ads_campaign_edit_session_id',
  adsTopupSessionId: 'ads_topup_session_id',

  adsDashboardDisplayedMetrics: 'adsDashboardDisplayedMetrics',
  adsAnalyticsDisplayedMetrics: 'adsAnalyticsDisplayedMetrics',
  adsAudienceInsightConversionMetrics: 'adsAudienceInsightConversionMetrics',
  adsDashboardConversionMetrics: 'adsDashboardConversionMetrics',
  farahDashboardDisplayedMetrics: 'farahDashboardDisplayedMetrics',
  farahAnalyticsDisplayedMetrics: 'farahAnalyticsDisplayedMetrics',
  farahAudienceInsightConversionMetrics:
    'farahAudienceInsightConversionMetrics',
  farahDashboardConversionMetrics: 'farahDashboardConversionMetrics',
  onboardingSession: 'onboarding-session',
  onboardingSessionTimeout: 'onboarding-session-timeout',
}
